var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSierraLeone22X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sierra_leone-2@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-493.000000, -560.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Sierra_leone-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.000000, 490.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.39,6.91 L0.39,15.91 L70.39,15.91 L70.39,6.91 C70.39,3.24282926 67.4171707,0.27 63.75,0.27 L7,0.27 C3.34455042,0.286515754 0.38996269,3.25451311 0.39,6.91 Z",
    id: "Shape",
    fill: "#57A863"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "0.39 31.61 70.39 31.61 70.39 15.94 0.39 15.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.39,40.62 C0.39,44.2871707 3.36282926,47.26 7.03,47.26 L63.75,47.26 C67.4171707,47.26 70.39,44.2871707 70.39,40.62 L70.39,31.62 L0.39,31.62 L0.39,40.62 Z",
    id: "Shape",
    fill: "#4A89DC"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierraLeone22X);
export default __webpack_public_path__ + "static/media/Sierra_leone-2@2x.5a7d2ac43a5b27da90c0f5a404600c39.svg";
export { ForwardRef as ReactComponent };